import React from 'react';

const Skills = () => {
    const skillCategories = [
        {
            title: 'PROGRAMMING',
            skills: ['C++', 'Python', 'JavaScript (Node.js)', 'Dart', 'MySQL']
        },
        {
            title: 'WEB & MOBILE DEVELOPMENT',
            skills: ['React', 'Flutter', 'Tailwind CSS', 'Redux', 'Socket.io']
        },
        {
            title: 'BACKEND & DATABASE',
            skills: ['REST API Development', 'JWT Authentication', 'Database Design & Queries', 'Express.js', 'Sequelize ORM', 'Multi-tenant Architecture', 'RBAC']
        },
        {
            title: 'TOOLS & CONCEPTS',
            skills: ['Git/GitHub', 'Postman', 'VS Code', 'Android Studio', 'UI/UX Basics', 'Modular Project Structure']
        },
        {
            title: 'AI-ASSISTED TOOLS',
            skills: ['Codex', 'GitHub Copilot', 'ChatGPT', 'Claude']
        },
        {
            title: 'AI & DATA ANNOTATION',
            skills: ['LIDAR', '2D/3D Annotation', 'Dataset Labeling', 'Spatial Measurements']
        },
        {
            title: 'ADDITIONAL',
            skills: ['Networking Setup & Troubleshooting', 'Microsoft Office Suite', 'Basic Video/Audio Editing', 'Cable Assembly & Hardware Setup']
        }
    ];

    return (
        <section id="skills" className="section" aria-labelledby="skills-heading">
            <h2 id="skills-heading" className="section-title">Skills</h2>
            <div className="skills-grid">
                {skillCategories.map((category, index) => (
                    <div key={index} className="skill-category">
                        <h3 className="skill-category-title">{category.title}</h3>
                        <ul className="skill-list">
                            {category.skills.map((skill, skillIndex) => (
                                <li key={skillIndex} className="skill-item">{skill}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Skills;
